module.exports = __webpack_public_path__ + "static/img/A1Copy.f921da5a.png";